export enum TipoActividad{
    DocumentoAgregado = 1,
    FijacionCreada = 2,
    AudienciaCelebrada = 3,
    SalaAsignada = 4,
    SalaRevocada = 5,
    MensajeTribunal = 6,
    AudienciaCancelada = 7,
    TwoFactorAuthenticator = 8,
    NuevaInstanciaDisponible = 10,
    ActivacionBuzon = 11,
    ActivacionBuzonPorInstancia = 12,
    DesactivacionDeInstancia = 13,
}